import { matchesSearchQuery } from "./searchMatcher";

const toStringValue = (value) => String(value ?? "").trim();

const toArray = (value) => {
  if (Array.isArray(value)) return value;
  if (!value) return [];
  return [value];
};

const getOrderData = (order) =>
  order && typeof order.raw === "object" && order.raw ? order.raw : order || {};

export function getOrderCategories(order) {
  const data = getOrderData(order);
  const directCategories = toArray(data.categories).map(toStringValue).filter(Boolean);
  const fallbackCategories = [
    toStringValue(data.category),
    toStringValue(data.type),
    toStringValue(data.transfollow?.orderCategory),
  ].filter(Boolean);

  return [...new Set([...directCategories, ...fallbackCategories])];
}

export function buildOrderSearchValues(order, driversById = {}) {
  const data = getOrderData(order);
  const driverId = toStringValue(data.userId);
  const driver = driverId ? driversById?.[driverId] || {} : {};
  const goodsNames = Array.isArray(data.transfollow?.structuredGoods)
    ? data.transfollow.structuredGoods.map((item) => toStringValue(item?.name)).filter(Boolean)
    : [];
  const driverTags = Array.isArray(driver.tags)
    ? driver.tags.map((tag) => toStringValue(tag)).filter(Boolean)
    : [];

  return [
    toStringValue(data.transportOrderRef),
    toStringValue(data.customerReference),
    toStringValue(data.internalReference),
    toStringValue(data.name),
    toStringValue(data.label),
    toStringValue(data.status),
    toStringValue(driver.name),
    ...driverTags,
    ...getOrderCategories(data),
    ...goodsNames,
  ].filter(Boolean);
}

export function matchesOrderSearch(order, query, driversById = {}) {
  return matchesSearchQuery(buildOrderSearchValues(order, driversById), query);
}

export function buildOrderSearchLabel(order, driversById = {}) {
  const data = getOrderData(order);
  const driverId = toStringValue(data.userId);
  const driverName = toStringValue(driversById?.[driverId]?.name);
  const categories = getOrderCategories(data).join(", ");
  return [
    toStringValue(data.internalReference),
    toStringValue(data.customerReference || data.transportOrderRef),
    toStringValue(data.label),
    driverName,
    categories,
  ]
    .filter(Boolean)
    .join(" - ");
}
